import React, { useEffect, useState } from "react";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  clearAuthError,
  fetchProfile,
  saveProfile,
} from "../../redux/authSlice";
import { GENDER } from "../../utils/constants";
import Loader from "../common/Loader";
import "../common/Account.css";

const Profile = () => {
  const dispatch = useDispatch();
  const { user, isLoading, error, message } = useSelector((s) => s.auth);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    gender: "",
    age: "",
    dateOfBirth: "",
    address: "",
    pincode: "",
    country: "India",
  });

  useEffect(() => {
    dispatch(fetchProfile());
    return () => dispatch(clearAuthError());
  }, [dispatch]);

  useEffect(() => {
    if (user) {
      setForm({
        firstName: user.firstName || "",
        lastName: user.lastName || "",
        email: user.email || "",
        gender: user.gender || "",
        age: user.age || "",
        dateOfBirth: user.dateOfBirth || "",
        address: user.address || "",
        pincode: user.pincode || "",
        country: user.country || "India",
      });
    }
  }, [user]);

  const onChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(
      saveProfile({
        ...form,
        gender: form.gender ? Number(form.gender) : undefined,
        age: form.age ? Number(form.age) : undefined,
      })
    );
  };

  return (
    <div className="account-page">
      {isLoading && <Loader overlay message="Saving..." />}
      <div className="coustom_container">
        <h1>My Profile</h1>
        <div className="account-card">
          {error && <Alert variant="danger">{error}</Alert>}
          {message && <Alert variant="success">{message}</Alert>}
          {!user && !isLoading ? (
            <Loader message="Loading profile..." />
          ) : (
            <Form onSubmit={onSubmit}>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>First name</Form.Label>
                    <Form.Control
                      name="firstName"
                      value={form.firstName}
                      onChange={onChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Last name</Form.Label>
                    <Form.Control
                      name="lastName"
                      value={form.lastName}
                      onChange={onChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={onChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Mobile</Form.Label>
                    <Form.Control value={user?.mobileNumber || ""} disabled />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Gender</Form.Label>
                    <Form.Select
                      name="gender"
                      value={form.gender}
                      onChange={onChange}
                    >
                      <option value="">Select</option>
                      <option value={GENDER.MALE}>Male</option>
                      <option value={GENDER.FEMALE}>Female</option>
                      <option value={GENDER.OTHER}>Other</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Age</Form.Label>
                    <Form.Control
                      type="number"
                      name="age"
                      value={form.age}
                      onChange={onChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Date of birth</Form.Label>
                    <Form.Control
                      type="date"
                      name="dateOfBirth"
                      value={form.dateOfBirth}
                      onChange={onChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={8}>
                  <Form.Group className="mb-3">
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                      name="address"
                      value={form.address}
                      onChange={onChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Pincode</Form.Label>
                    <Form.Control
                      name="pincode"
                      value={form.pincode}
                      onChange={onChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Button type="submit" className="btn-kior">
                Save profile
              </Button>
            </Form>
          )}
        </div>
      </div>
    </div>
  );
};

export default Profile;
